<template>
  <div class="org-item">
    {{ row[col] }}
    <el-tag
      v-if="row['orgInfo'].isCampusActive"
      type="success"
      effect="dark"
      size="mini"
    >
      校本
    </el-tag>
    <el-tag
      v-if="row['orgInfo'].is430Active"
      type="warning"
      effect="dark"
      size="mini"
    >
      社团
    </el-tag>
    <el-tag v-if="row['orgInfo'].isOrgActive" effect="dark" size="mini">
      机构
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'OrgItem',
  props: {
    col: String,
    row: Object,
  },
}
</script>

<style>
</style>